import React, { useState } from "react";
import "./style.css";
import { useDispatch } from "react-redux";
import { LoginData } from "../../models/LoginData";
import { logInWithPassword } from "../../store/auth/authActions";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { useNavigate } from "react-router";
import { REGISTRATION_PAGE, REMIND_PASS_PAGE } from "../../routes";
import useFacility from "../../../utils/hooks/useFacility";

const initialFormLogin: LoginData = {
  login: "",
  password: "",
  objectIds: "",
  old_token: "",
};

const Login: React.FC = () => {
  const isDesktop = useDesktopSize();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const facilityIds = useFacility();
  const [form, setForm] = useState<LoginData>({ ...initialFormLogin, objectIds: facilityIds });

  return (
    <div className={isDesktop ? "login-wrapper" : "login-wrapper-mobile"}>
      <div className={isDesktop ? "login-panel" : "login-panel-mobile"}>
        <h3 className={isDesktop ? "login-panel-title" : "login-panel-title-mobile"}>Zaloguj się</h3>
        <div className={"panel-form"}>
          <label className={"label-input"} htmlFor={"email"}>
            E-mail
          </label>
          <input
            type={"text"}
            id={"email"}
            name={"email"}
            placeholder={"E-mail"}
            value={form.login}
            onChange={(event) => setForm({ ...form, login: event.target.value })}
          />
        </div>
        <div className={"panel-form"}>
          <label className={"label-input"} htmlFor={"password"}>
            Hasło:
          </label>
          <input
            type={"password"}
            id={"password"}
            name={"password"}
            placeholder={"Hasło"}
            value={form.password}
            onChange={(event) => setForm({ ...form, password: event.target.value })}
          />
        </div>
        <div className={"div-buttons"}>
          <button className={"login-button"} onClick={() => dispatch(logInWithPassword(form))}>
            Zaloguj
          </button>
          <span>lub</span>
          <button className={"register-button"} onClick={() => navigate(REGISTRATION_PAGE)}>
            Załóż konto
          </button>
        </div>
        <div className={"div-buttons"}>
          <button onClick={() => navigate(REMIND_PASS_PAGE)} className={"remember-pass-button"}>
            Nie pamiętam hasła
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
